import { render, staticRenderFns } from "./information-change-conclusion.vue?vue&type=template&id=86bee078&scoped=true&"
import script from "./information-change-conclusion.vue?vue&type=script&lang=js&"
export * from "./information-change-conclusion.vue?vue&type=script&lang=js&"
import style0 from "./information-change-conclusion.vue?vue&type=style&index=0&id=86bee078&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bee078",
  null
  
)

export default component.exports